const liveMap = {
  layers: {
    title: 'Camada do mapa',

    filters: {
      powerType: {
        title: 'Capacidade de carregamento',
        placeholder: 'Capacidade de carregamento',
        options: {
          fast: 'Rápido',
          slow: 'Lento',
          turbo: 'Turbo',
        },
      },

      operator: {
        title: 'Operador de Ponto de Carga',
      },

      connectorType: {
        title: 'Tipo de Conector',
        placeholder: 'Tipo de Conector',
        options: {
          EC_Type_1: 'IEC Tipo 1',
          IEC_Type_2_J1772: 'IEC Tipo 2 (J1772)',
          IEC_Type_2: 'IEC Tipo 2',
          IEC_Type_3: 'IEC Tipo 3',
          CHAOJI: 'CHAOJI',
          NEMA: 'NEMA',
          TESLA: 'tesla',
          CHADEMO: 'Chademo',
          GBT: 'GBT',
        },
      },

      vehicles: {
        title: 'Veículos',
      },
    },

    content: {
      traffic: {
        title: 'Tráfego',
        description: 'Descrição da camada explicando o que mostramos no mapa',
        mildlyhigher: 'Ligeiramente Mais Alta',
        trafficJam: 'Engarrafamento',
      },

      evsChargingPoints: {
        title: 'Pontos de Carregamento de Veículos Elétricos',
        description: 'Descrição da camada explicando o que mostramos no mapa',
        chargingPointOptions: {
          fast: 'Ponto de Carregamento Rápido',
          slow: 'Ponto de Carregamento Lento',
        },
      },

      heatMap: {
        title: 'Mapa de Calor',
        description: 'Descrição da camada explicando o que mostramos no mapa',
        scaleOfDemand: 'Escala de Demanda',
      },

      dots: {
        title: 'Pontos',
        description: 'Descrição da camada explicando o que vamos no mapa',
        numberOfDemands: 'Número de demanda',
      },

      tripsLiveStream: {
        title: 'Transmissões de viagens ao vivo',
        description: 'Descrição da camada explicando o que mostramos no mapa',
        tripProgress: 'Andamento da Viagem',
        pickUp: 'Recolher',
        dropOff: 'Devolução',
      },
    },
  },
};

export default liveMap;
